export interface CustomerProfile {
  id: string;
  businessName: string;
  contactPerson: string;
  avatarUrl?: string;
  status: 'Active' | 'Inactive' | 'Suspended';
  creditLimit: string;
  paymentTerms: string;
}

export interface BusinessInfo {
  businessName: string;
  businessAddress: string;
  taxId: string;
  businessLicense: string;
  licenseDocumentUrl?: string;
}

export interface ContactInfo {
  contactPerson: string;
  email: string;
  phone: string;
  deliveryAddress: string;
}

export interface NotificationPreference {
  id: string;
  label: string;
  enabled: boolean;
}

export interface SecurityOption {
  id: string;
  label: string;
}

export interface SettingsItem {
  id: string;
  icon: 'bell' | 'globe' | 'wifi' | 'gear';
  title: string;
  subtitle: string;
}

export const defaultNotificationPreferences: NotificationPreference[] = [
  { id: 'order-updates', label: 'Order Updates', enabled: true },
  { id: 'delivery-notifications', label: 'Delivery notifications', enabled: true },
  { id: 'payment-reminders', label: 'Payment Reminders', enabled: true },
  { id: 'promotional-offers', label: 'Promotional Offers', enabled: false },
];

export const defaultSecurityOptions: SecurityOption[] = [
  { id: 'change-password', label: 'Change Password' },
  { id: 'two-factor', label: 'Two-Factor Authentication' },
];

export const defaultSettingsItems: SettingsItem[] = [
  { id: 'notifications', icon: 'bell', title: 'Notifications', subtitle: 'Manage notification preferences' },
  { id: 'language', icon: 'globe', title: 'Language', subtitle: 'English (US)' },
  { id: 'offline-mode', icon: 'wifi', title: 'Offline Mode', subtitle: 'Sync when online' },
  { id: 'general', icon: 'gear', title: 'General Settings', subtitle: 'App preferences and defaults' },
];
